import React from 'react';
import { Tag, Tooltip } from 'antd';
import { formatDateTime } from '../../../Utils/dateFormat';

const methodColors = {
  GET: 'blue',
  POST: 'green',
  PUT: 'orange',
  DELETE: 'red',
  PATCH: 'purple'
};

const getStatusColor = code => {
  if (code >= 200 && code < 300) return 'green';
  if (code >= 400 && code < 500) return 'orange';
  if (code >= 500) return 'red';
  return 'default';
};

export const columns = [
  {
    id: 'timeOfRequest',
    accessorKey: 'timeOfRequest',
    header: 'Request Time',
    size: 180,
    minSize: 140,
    maxSize: 500,
    enableSorting: false,
    cell: ({ getValue }) => {
      const val = getValue();
      return val ? formatDateTime(val) : '-';
    }
  },
  {
    id: 'timeOfResponse',
    accessorKey: 'timeOfResponse',
    header: 'Response Time',
    size: 180,
    minSize: 140,
    maxSize: 500,
    enableSorting: false,
    cell: ({ getValue }) => {
      const val = getValue();
      return val ? formatDateTime(val) : '-';
    }
  },
  {
    id: 'method',
    accessorFn: row => row.request?.method,
    header: 'Method',
    size: 100,
    minSize: 80,
    maxSize: 200,
    enableSorting: false,
    cell: ({ getValue }) => {
      const val = getValue();
      return <Tag color={methodColors[val] || 'default'}>{val || '-'}</Tag>;
    }
  },
  {
    id: 'uri',
    accessorFn: row => row.request?.uri,
    header: 'URI',
    size: 300,
    minSize: 150,
    maxSize: 800,
    enableSorting: false,
    cell: ({ getValue }) => {
      const val = getValue();
      return (
        <Tooltip title={val}>
          <span
            style={{
              display: 'block',
              maxWidth: 280,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            {val || '-'}
          </span>
        </Tooltip>
      );
    }
  },
  {
    id: 'statusCode',
    accessorFn: row => row.response?.statusCode,
    header: 'Status',
    size: 100,
    minSize: 80,
    maxSize: 200,
    enableSorting: false,
    cell: ({ getValue }) => {
      const val = getValue();
      return (
        <Tag color={getStatusColor(val)}>{val != null ? val : '-'}</Tag>
      );
    }
  },
  {
    id: 'duration',
    accessorKey: 'duration',
    header: 'Duration (ms)',
    size: 130,
    minSize: 100,
    maxSize: 300,
    enableSorting: false,
    cell: ({ getValue }) => {
      const val = getValue();
      return val != null ? `${val}` : '-';
    }
  },
  {
    id: 'source',
    accessorKey: 'source',
    header: 'Source',
    size: 150,
    minSize: 100,
    maxSize: 300,
    enableSorting: false,
    cell: ({ getValue }) => getValue() || '-'
  },
];
